<div id="header">
  <div class="container-fluid">
    <div class="row">
      <div class="col-9 no-pad-left">
        <h1>
          {{ title }} <span *ngIf="subTitle != ''">{{ subTitle }}</span>
        </h1>

        <div
          *ngIf="datePicker"
          class="datePicker icn-calendar"
          (click)="datePicker.toggleCalendar()"
        >
          <span
            angular-mydatepicker
            [(ngModel)]="datePickerModel"
            [options]="datePickerOptions"
            #datePicker="angular-mydatepicker"
            (dateChanged)="datePickerChanged($event)"
            >{{ today }}</span
          >
        </div>
      </div>

      <div class="col">
        <div class="user-menu">
          <div class="area" userMenu (outsideUserMenu)="openUserMenu($event)">
            <i (click)="openUserMenu(true)">{{ userName }}</i>

            <span class="icn-arrow-down" [class.icn-arrow-up]="userMenu"></span>

            <ul *ngIf="userMenu">
              <!-- <li><button>Perfil</button></li>
              <li class="bar"></li> -->
              <li><button (click)="logout()">Logout</button></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
